var _defs, _path, _g, _path2, _polygon, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RocketColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "22.3693106%",
    x2: "100.11408%",
    y2: "24.782496%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "22.3693159%",
    x2: "100.11408%",
    y2: "24.7824966%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1096,2.48608088 C75.848,-0.828673125 85.152,-0.828704125 90.89,2.48605088 L156.696,40.4981009 C159.786,42.2827009 161.212,44.6643009 160.975,47 L161.000331,47 L161.000331,82 L160.975,82 C160.771,84.0027009 159.345,85.9717009 156.696,87.5019009 L90.89,125.514001 C85.152,128.829001 75.848,128.829001 70.1096,125.514001 L4.3038,87.5019009 C1.6549,85.9717009 0.2288,84.0027009 0.0254,82 L0,82 L0,47 L0.0254,47 C-0.2118,44.6643009 1.2144,42.2827009 4.3038,40.4981009 L70.1096,2.48608088 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391049%",
    y1: "48.8133347%",
    x2: "93.8845102%",
    y2: "50.2027192%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.01754386%",
    y1: "50%",
    x2: "96.8463158%",
    y2: "47.3393352%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "41.5815%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "78.6683%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0394224%",
    y1: "47.9825448%",
    x2: "93.9168281%",
    y2: "49.3725376%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.1515528%",
    y1: "49.4736559%",
    x2: "3.03031056%",
    y2: "49.4736559%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1096,2.48607088 L4.3038,40.4981009 C1.5481,42.0899009 0,44.2488009 0,46.5000009 C0,48.7511009 1.5481,50.9101009 4.3038,52.5019009 L70.1096,90.5139009 C72.8653,92.1057009 76.6029,93.0000009 80.5,93.0000009 C84.3971,93.0000009 88.135,92.1057009 90.89,90.5139009 L156.696,52.5019009 C159.452,50.9101009 161,48.7511009 161,46.5000009 C161,44.2489009 159.452,42.0899009 156.696,40.4981009 L90.89,2.48607088 C88.135,0.894266875 84.3971,8.75052621e-07 80.5,8.75052621e-07 C76.6028,8.75052621e-07 72.8653,0.894265875 70.1096,2.48607088 Z M100.996,48.1179009 C116.07,39.4145009 117.841,26.1945009 114.586,24.3153009 C111.312,22.4252009 88.414,23.4472009 73.3394,32.1506009 C64.2031,37.4254009 59.635,42.7003009 59.1591,47.0190009 C59.083,47.5245009 59.4066,48.0190009 60.0347,48.3817009 L72.9016,55.8104009 C73.5107,56.1621009 74.3672,56.3489009 75.2618,56.3159009 C82.7231,56.0302009 91.84,53.4038009 100.996,48.1179009 Z M100.881,40.4475009 C96.941,42.7222009 90.584,42.7222009 86.644,40.4475009 C82.704,38.1727009 82.704,34.5023009 86.644,32.2275009 C90.565,29.9638009 96.96,29.9638009 100.881,32.2275009 C104.802,34.4913009 104.802,38.1837009 100.881,40.4475009 Z M58.5126,34.6892009 L64.0515,34.4804009 C59.7879,37.6893009 56.9138,40.9311009 55.6004,44.0630009 C55.353,44.6674009 55.1626,45.2608009 55.0294,45.8433009 L49.0718,45.0630009 C46.9019,44.7773009 45.9312,43.3157009 47.1874,42.2608009 L54.782,35.9200009 C55.6195,35.1947009 57.0089,34.7442009 58.5126,34.6892009 Z M96.599,56.6787009 L96.942,53.4918009 C91.403,55.9424009 85.769,57.6128009 80.3822,58.3710009 C79.3354,58.5139009 78.3076,58.6238009 77.2988,58.7007009 L78.6502,62.1403009 C79.145,63.3931009 81.6765,63.9536009 83.5038,63.2283009 L94.486,58.8436009 C95.724,58.3490009 96.504,57.5468009 96.599,56.6787009 Z M59.5017,50.0083009 C59.5017,50.0083009 58.9878,50.2391009 58.7403,50.3820009 C55.7901,52.0853009 55.7901,54.8546009 58.7403,56.5579009 C61.6906,58.2612009 66.4871,58.2612009 69.4374,56.5579009 C69.6658,56.4260009 69.8942,56.2722009 70.0845,56.1183009 L70.0655,56.3491009 C69.6087,60.4151009 63.6511,63.8767009 56.6276,64.1734009 L44.6553,64.6899009 L45.5499,57.7777009 C46.0447,53.8875009 51.5836,50.5578009 58.2264,50.0633009 C58.4739,50.0523009 59.5017,50.0083009 59.5017,50.0083009 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "RocketColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 0.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1096,12.4861009 C75.848,9.17133088 85.152,9.17130088 90.89,12.4861009 L156.696,50.4981009 C159.786,52.2827009 161.212,54.6643009 160.975,57.0000009 L161.000331,57.0000009 L161.000331,92.0000009 L160.975,92.0000009 C160.771,94.0027009 159.345,95.9717009 156.696,97.5019009 L90.89,135.514001 C85.152,138.829001 75.848,138.829001 70.1096,135.514001 L4.3038,97.5019009 C1.6549,95.9717009 0.2288,94.0027009 0.0254,92.0000009 L0,92.0000009 L0,57.0000009 L0.0254,57.0000009 C-0.2118,54.6643009 1.2144,52.2827009 4.3038,50.4981009 L70.1096,12.4861009 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.8,
    filter: "url(#filter-2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.68,2.37914088 C84.3341,-0.793046125 75.6659,-0.793046125 70.3195,2.37914088 L9.0098,38.7562009 C3.6634,41.9284009 3.6634,47.0716009 9.0098,50.2438009 L70.3195,86.6209009 C75.6659,89.7931009 84.3341,89.7930009 89.68,86.6209009 L150.99,50.2438009 C156.337,47.0716009 156.337,41.9284009 150.99,38.7562009 L89.68,2.37914088 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.366,33.8157009 C117.621,35.6948009 115.851,48.9149009 100.776,57.6183009 C91.621,62.9041009 82.5034,65.5305009 75.0421,65.8163009 C74.1475,65.8492009 73.291,65.6624009 72.6819,65.3108009 L59.815,57.8821009 C59.1869,57.5194009 58.8633,57.0249009 58.9394,56.5194009 C59.4153,52.2006009 63.9834,46.9258009 73.1197,41.6510009 C88.194,32.9475009 111.092,31.9255009 114.366,33.8157009 Z M86.424,49.9478009 C90.364,52.2226009 96.722,52.2226009 100.662,49.9478009 C104.583,47.6841009 104.583,43.9917009 100.662,41.7279009 C96.741,39.4641009 90.345,39.4641009 86.424,41.7279009 C82.4843,44.0027009 82.4843,47.6731009 86.424,49.9478009 Z",
    id: "Shape",
    fillOpacity: 0.2,
    fill: "#383648",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.379,66.1791009 L96.722,62.9922009 C91.183,65.4428009 85.549,67.1131009 80.1625,67.8714009 C79.1157,68.0143009 78.0878,68.1241009 77.079,68.2011009 L78.4304,71.6407009 C78.9253,72.8935009 81.4568,73.4539009 83.2841,72.7286009 L94.267,68.3439009 C95.504,67.8494009 96.284,67.0472009 96.379,66.1791009 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "#383648",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5206,59.8823009 C58.7681,59.7395009 59.282,59.5087009 59.282,59.5087009 C59.282,59.5087009 58.2541,59.5527009 58.0067,59.5637009 C51.3639,60.0582009 45.825,63.3879009 45.3301,67.2781009 L44.4355,74.1903009 L56.4079,73.6738009 C63.4314,73.3771009 69.389,69.9155009 69.8458,65.8495009 L69.8648,65.6187009 C69.6745,65.7726009 69.4461,65.9264009 69.2177,66.0583009 C66.2674,67.7616009 61.4709,67.7616009 58.5206,66.0583009 C55.5704,64.3549009 55.5704,61.5857009 58.5206,59.8823009 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "#383648",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    points: "70.3965 56.2233009 70.3965 59.5983009 63.6465 65.5983009 50.5215 67.3483009 43.6465 65.5983009 41.8965 60.9733009 43.6465 54.2233009 51.2715 48.5983009 60.5215 49.8483009 68.1465 54.2233009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6465,36.9733009 L103.521,36.9733009 L103.521,46.3483009 C103.521,49.6620009 100.835,52.3483009 97.521,52.3483009 L89.646,52.3483009 C86.333,52.3483009 83.6465,49.6620009 83.6465,46.3483009 L83.6465,36.9733009 Z",
    id: "Path",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-9)",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketColor);
export default __webpack_public_path__ + "static/media/RocketColor.9c72eed2538fccb0beaf0c6632ccff07.svg";
export { ForwardRef as ReactComponent };